import {WorkrequestDetailsBase} from '../../shared/data-objects/workrequest-details-base';

export class WorkrequestSrpDetails extends WorkrequestDetailsBase {
  applicationFeerequired: boolean;
  newHouse1required: boolean;
  newHouse2required: boolean;
  NewOrExistingHouserequired: boolean;
  demolitionAndRebuildrequired: boolean;
  houseExtensionrequired: boolean;
  assessAndDesignrequired: boolean;
  belowGroundSewerWorkrequired: boolean;
  waterConsentOnlyrequired: boolean;
  propertyOnCombinedDrain: string;
  divewayResponsibleOwner: string;
  requiredWorkRequest: string;
  isUserDriveway: boolean;
  isRecycledSelected: boolean;

  constructor() {
    super();
    this.applicationFeerequired = true;
    this.newHouse1required = false;
    this.newHouse2required = false;
    this.NewOrExistingHouserequired = false;
    this.demolitionAndRebuildrequired = false;
    this.houseExtensionrequired = false;
    this.assessAndDesignrequired = false;
    this.belowGroundSewerWorkrequired = false;
    this.waterConsentOnlyrequired = false;
    this.isUserDriveway = false;
    this.isRecycledSelected = false;
  }

  toUpperCase() {
    if (this.descriptionOfWork) {
      this.descriptionOfWork = this.descriptionOfWork.toUpperCase();
    }
  }

  appendWorkRequestDescription(detailedDescription: string) {
    if (!this.descriptionOfWork) {
      this.descriptionOfWork = '';
    }
    this.descriptionOfWork = detailedDescription;
    this.descriptionOfWork += '\r\n';
    this.descriptionOfWork += 'Note: ' + '\r\n';
    if (this.divewayResponsibleOwner === 'nodriveway') {
      this.descriptionOfWork += '1) ' + ' There is no driveway works.';
    } else if (this.divewayResponsibleOwner === 'existingdriveway') {
      this.descriptionOfWork += '1) ' + ' There is an Existing driveway.';
    } else {
      this.descriptionOfWork += '1) ' + this.divewayResponsibleOwner + ' is responsible for driveway work';
    }
  }

  appendCombinedDrainDescription() {
    if (!this.descriptionOfWork) {
      this.descriptionOfWork = '';
    }
    this.descriptionOfWork += '\r\n';
    this.descriptionOfWork += '2) Property on combined drain: ' + (this.propertyOnCombinedDrain ? this.propertyOnCombinedDrain : 'Unknown');
  }

  appendPlotsAttachmentConfirmationDescription() {
    if (!this.descriptionOfWork) {
      this.descriptionOfWork = '';
    }
    this.descriptionOfWork += '\r\n';
    this.descriptionOfWork += '3) I confirm that the plans attached/upload in dropbox to ' +
      'this application are final and for construction purposes. ' +
      'Any amendments will require a new application NB: no approximate measurements/offsets will be accepted. Yes';
  }
}



// WEBPACK FOOTER //
// ./src/app/create-application/srp-form/workrequest-srp-details.ts